<style scoped>
.v-snack {
  top: 40px;
}
</style>
<template>
  <v-snackbar
    color="#2196f3"
    v-model="basketSnackbar"
    :right="true"
    :top="true"
    :timeout="6000"
  >
    {{ mostRecentAddedMaterialNo }} added to the Basket
    <v-btn flat small @click="dismissSnackbar">
      <v-icon small>close</v-icon>
    </v-btn>
  </v-snackbar>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters("basket", ["mostRecentAddedMaterialNo"]),
    basketSnackbar: {
      get() {
        return this.$store.state.basket.snackbar;
      },
      set() {
        this.dismissSnackbar();
      }
    }
  },
  methods: mapActions("basket", ["dismissSnackbar"])
};
</script>
